<template>
  <form class="contact-travel-expert" @submit.prevent="onSubmit">
    <div
      class="contact-travel-expert__title font-h1 u-text-center"
      v-html="$t('contactTravelExpert.title')"
    ></div>
    <a :href="link" target="_blank" class="contact-travel-expert__avatar">
      <avatar :name="expertData.first_name" :photo="expertData.avatar" />
    </a>
    <div class="contact-travel-expert__message">
      <div class="contact-travel-expert__message-corner u-absolute-center-x">
        <svg-inline name="bubble-corner">
          <icon icon="bubble-corner" />
        </svg-inline>
      </div>
      <div
        class="font-text-small u-text-center"
        v-html="
          $t(`contactTravelExpert.message${tourName ? 'Tour' : ''}`, {
            name: expertData.first_name,
            tour: tourName,
          })
        "
      ></div>
    </div>
    <div class="contact-travel-expert__input">
      <text-area
        :value="$v.formData.message.$model"
        :placeholder="$t('contactTravelExpert.placeholder')"
        @field-input="$v.formData.message.$model = $event"
      >
        <template #error-helper>
          <div
            v-if="$v.formData.message.$error"
            v-html="getVuelidateErrorMessage($v.formData.message)"
          ></div>
        </template>
      </text-area>
    </div>
    <div class="contact-travel-expert__submit">
      <yt-button
        type="submit"
        :disabled="$v.formData.$error"
        class="contact-travel-expert__submit-button"
      >
        {{ $t("contactTravelExpert.submit") }}
      </yt-button>
    </div>
    <div
      class="font-text-small u-text-secondary u-text-center"
      v-html="$t('common.terms')"
    ></div>
  </form>
</template>

<script>
import qs from "qs";
import Avatar from "@/components/ui-kit/avatar/index.vue";
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import Icon from "@/components/icons/index.vue";
import TextArea from "@/components/atoms/field-area/index.vue";
import YtButton from "@/components/ui-kit/yt-button/index.vue";
import { required } from "vuelidate/lib/validators";
import getExpertLink from "@/assets/js/utils/get-expert-link";
import getVuelidateErrorMessage from "@/assets/js/utils/get-vuelidate-error-message";

export default {
  components: {
    Avatar,
    SvgInline,
    Icon,
    TextArea,
    YtButton,
  },
  props: {
    expertData: {
      type: Object,
      required: true,
    },
    tourName: {
      type: String,
      default: "",
    },
    tripId: {
      type: [String, Number],
      default: undefined,
    },
  },
  data() {
    return {
      formData: {
        message: "",
      },
    };
  },
  validations: {
    formData: {
      message: {
        required,
      },
    },
  },
  computed: {
    link() {
      return getExpertLink(this.expertData.id);
    },
  },
  methods: {
    onSubmit() {
      this.$v.formData.$touch();

      if (this.$v.formData.$invalid) {
        return;
      }

      // @todo future api

      const {
        expertData,
        tripId,
        formData: { message },
      } = this;

      let ytObj = youtravel || {};
      if (typeof ytObj.ModalController !== "undefined") {
        ytObj.ModalController.openModal({
          ajax_mode: true,
          ajax_type: "POST",
          ajax_url: "/local/ajax/booking/ajax.booking.php",
          bodyRequest: qs.stringify({
            sessid: fakeWindow.BX.bitrix_sessid(),
            data: {
              expert_id: expertData.id,
              trip_id: tripId,
              msg: message,
            },
            init_action: "SendMessageToExpert",
            action: "SendMessageToExpert",
            backurl: fakeWindow.location?.pathname,
          }),
        });
      }

      this.$emit("done");
      this.formData.message = "";
      this.$v.formData.$reset();
    },
    getVuelidateErrorMessage,
  },
};
</script>

<style lang="scss" scoped>
.contact-travel-expert {
  &__title {
    margin-bottom: 27px;
  }

  &__avatar {
    display: block;
    width: 64px;
    margin: 0 auto 18px;
  }

  &__message {
    position: relative;
    padding: 20px 24px;
    background: var.$gray-light;
    border-radius: 16px;
    margin-bottom: 32px;

    &-corner {
      bottom: calc(100% - 1px);
      width: 26px;
    }
  }

  &__input,
  &__submit {
    margin-bottom: 20px;
  }

  &__submit {
    &-button {
      width: 100%;
    }
  }
}
</style>
